import { isFuture, isToday } from "date-fns";
import { checkForEmptyNamesCamelCase } from "../../Sbb/helpers/checkForEmptyNames";
import { type FrankfurtCardOffer, type FrankfurtCardPassenger } from "../types";

// Backend rejects estimations with more travellers than this (FrankfurtCardEstimationRequestDetails::MAX_PASSENGERS).
export const FRANKFURT_CARD_MAX_PASSENGERS = 5;

export type FrankfurtCardSeePriceValidationResult = {
  isValid: boolean;
  offerMissing: boolean;
  dateInPast: boolean;
  passengersMissing: boolean;
  tooManyPassengers: boolean;
  hasInvalidNames: boolean;
};

export function validateFrankfurtCardSeePrice(params: {
  selectedOffer: FrankfurtCardOffer | null;
  selectedDate: Date;
  passengerList: FrankfurtCardPassenger[];
}): FrankfurtCardSeePriceValidationResult {
  const { selectedOffer, selectedDate, passengerList } = params;

  const offerMissing = !selectedOffer?.offer_code;
  const dateInPast = !(isToday(selectedDate) || isFuture(selectedDate));
  const passengersMissing = passengerList.length === 0;
  const tooManyPassengers = passengerList.length > FRANKFURT_CARD_MAX_PASSENGERS;
  const hasInvalidNames = checkForEmptyNamesCamelCase(passengerList);

  return {
    isValid: !offerMissing && !dateInPast && !passengersMissing && !tooManyPassengers && !hasInvalidNames,
    offerMissing,
    dateInPast,
    passengersMissing,
    tooManyPassengers,
    hasInvalidNames
  };
}
